import { Link, useSearchParams } from "react-router-dom";
import { TOPICS } from "../../constants";
import { CLASS_ROUTE } from "@/constant/urlConstant";
import { trackClassTopicClicked } from "@/tracking";
import { cls } from "../../utils/util";
import { useEffect, useState } from "react";
import { TopicsMenuPopup } from "./TopicsMenu";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper";
import type { Swiper as SwiperClass } from "swiper";

const TopicsNavbar = () => {
  const [topicsMenuDisplay, setTopicsMenuDisplay] = useState<boolean>(false);
  const [searchParams] = useSearchParams();
  const topics = searchParams.get("topics") || "전체";
  const [swiperInstance, setSwiperInstance] = useState<SwiperClass | null>(null);

  const activeIndex =
    topics === "전체"
      ? 0
      : TOPICS.findIndex((topic) => topic.label.replace(/\s+/g, "") === topics) + 1;

  useEffect(() => {
    swiperInstance?.slideTo(activeIndex, 0);
  }, [swiperInstance, activeIndex]);

  return (
    <div className="h-[44px] lg:h-[50px] border-b border-solid border-b-gray-300 relative">
      <Swiper
        modules={[FreeMode]}
        freeMode
        grabCursor
        slidesPerView="auto"
        initialSlide={activeIndex}
        onSwiper={setSwiperInstance}
        breakpoints={{ 1024: { slidesOffsetAfter: 100 } }}
        className="mx-[6px] h-[44px] lg:h-[50px] text-[18px] lg:mx-[-10px]"
      >
        <SwiperSlide className="!w-auto">
          <Link
            className={cls(
              "block relative h-[44px] lg:h-[50px] leading-[50px] px-[10px] font-medium text-[16px] lg:font-semibold lg:text-[18px]",
              "전체" === topics ? "text-medi-color-purple-600" : "text-medi-text-primary",
            )}
            to={`/${CLASS_ROUTE}/search`}
            onClick={() => trackClassTopicClicked({ topic: "전체" })}
          >
            전체
            <span
              className={cls(
                "absolute right-[10px] bottom-0 left-[10px] h-[4px]",
                "전체" === topics ? "bg-medi-color-purple-600" : "bg-transparent",
              )}
            ></span>
          </Link>
        </SwiperSlide>
        {TOPICS.map((topic) => {
          return (
            <SwiperSlide className="!w-auto" key={topic.name}>
              {/* '/' 나 '&' 과 같이 URL 구분자의 충돌을 일으킬 가능성이 큰 문자는 인코딩 합니다. */}
              <Link
                className={cls(
                  "block relative h-[44px] lg:h-[50px] leading-[50px] px-[10px] font-medium text-[16px] lg:font-semibold lg:text-[18px]",
                  topic.label.replace(/\s+/g, "") === topics
                    ? "text-medi-color-purple-600"
                    : "text-medi-text-primary",
                )}
                to={`/${CLASS_ROUTE}/search?topics=${topic.label
                  .replace(/\s+/g, "")
                  .replace("/", encodeURIComponent("/"))
                  .replace("&", encodeURIComponent("&"))}`}
                onClick={() => trackClassTopicClicked({ topic: topic.label })}
              >
                {topic.label}
                <span
                  className={cls(
                    "absolute right-[10px] bottom-0 left-[10px] h-[4px]",
                    topic.label.replace(/\s+/g, "") === topics
                      ? "bg-medi-color-purple-600"
                      : "bg-transparent",
                  )}
                ></span>
              </Link>
            </SwiperSlide>
          );
        })}
      </Swiper>
      <div
        className="pointer-events-none z-10 hidden lg:flex lg:items-center lg:justify-end lg:pr-[10px] w-[100px] h-full cursor-pointer absolute right-[-10px] top-0"
        style={{
          background: "linear-gradient(270deg, #FFFFFF 70%, rgba(255, 255, 255, 0) 100%)",
        }}
      >
        <div
          onClick={() => setTopicsMenuDisplay(!topicsMenuDisplay)}
          className="pointer-events-auto hidden lg:flex lg:justify-center lg:items-center shadow-card bg-white w-[35px] h-[35px] rounded-full"
        >
          <i
            className={cls(
              topicsMenuDisplay ? "ii-chevron-up" : "ii-chevron-down",
              "text-gray-900 text-[20px]",
            )}
          ></i>
        </div>
      </div>
      {topicsMenuDisplay && <TopicsMenuPopup setTopicsMenuDisplay={setTopicsMenuDisplay} />}
    </div>
  );
};

export default TopicsNavbar;
